import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/storage'
import 'firebase/messaging'

import {API_PAYPAL, PRODUCCION} from '@/constantes/environment'


// Initialize Firebase PRODUCTION

let configuracion = '';

if(PRODUCCION){
  configuracion = {
    apiKey: "AIzaSyCb8qO3cDa5pMUvp9_BVlOfdvzxTRgEk3A",
    authDomain: "pixan-cloud.firebaseapp.com",
    databaseURL: "https://pixan-cloud.firebaseio.com",
    projectId: "pixan-cloud",
    storageBucket: "pixan-cloud.appspot.com",
    messagingSenderId: "968142791941",
    appId: "1:968142791941:web:6b11260b7a3930cd"
  }
}else{
  //PRUEBAS TEST
  configuracion = {
    apiKey: "AIzaSyBLAMSt46hOVbSkOp36Tn_Jgk-XZvY3tbQ",
    authDomain: "pixancloud-test.firebaseapp.com",
    databaseURL: "https://pixancloud-test.firebaseio.com",
    projectId: "pixancloud-test",
    storageBucket: "pixancloud-test.appspot.com",
    messagingSenderId: "670432076133",
    appId: "1:670432076133:web:c00acdacd42afac218418c"
  };
}


export const config = configuracion;


// Initialize Firebase TEST







firebase.initializeApp(config)
export default firebase

export const FS_COLLECTIONS = {
  PERFILES: 'Perfiles',
  USUARIOS: 'Usuarios',
  PIXAN: 'Pixan',
  EMPLEADOS: 'Empleados',
  PROPIETARIOS: 'Propietarios',
  PACIENTES: 'Pacientes',
  CORPORATIVOS: 'Corporativos',
  FRANQUICIAS: 'Franquicias',
  SUCURSALES: 'Sucursales',
  INDICES: 'Indices',
  CATALOGOS: 'Catalogos',
  ESPECIES: 'Especies',
  PRODUCTOS: 'Productos',
  SERVICIOS: 'Servicios',
  CASOS: 'Casos',
  ESTUDIOS: 'Estudios',
  ESPACIOS: 'Espacios',
  AGENDA: 'Agenda',
  AGENDA_NUEVA:'Agenda_Nueva',
  PLANES_BIENESTAR: 'Planes_Bienestar',
  CORTES_CAJA: 'Cortes_Caja',
  CORTES_CAJA_INDICES: 'Cortes_Caja_Indices',
  TICKETS: 'Tickets',
  TICKETS_INDICES: 'Tickets_Indices_Nuevo',
  CORTES_INDICES: 'Cortes_Indices',
  CAJAS: 'Cajas',
  SERVICIOS_CASOS_INDICES: 'ServiciosCasos_Indices',
  SERVICIOS_CASOS: 'ServiciosCasos',
  CASOS_INDICES: 'Casos_Indices',
  DESCUENTOS: 'Descuentos',
  ROLES: 'Roles',
  TICKET_ID: 'Ticket_id',
  FORMATOS: 'Formatos',
  NTF_PROGRAMADAS: 'NTFProgramadas',
  NTF_USUARIOS: 'NTFUsuarios',
  NTF_PROPIETARIOS: 'NTFPropietarios',
  ALMACENES:'Almacenes',
  PROVEEDORES:'Proveedores',
  UNIDADES:"Unidades",
  COMPRAS:'Compras',
  VENTAS_MOSTRADOR:'Ventas_Mostrador',
  VENTAS_MOSTRADOR_INDICES:'Ventas_Mostrador_Indices',
  TICKETS_VENTAS_MOSTRADOR:'Tickets_Ventas_Mostrador',
  TICKETS_VENTAS_MOSTRADOR_INDICES:'Tickets_Ventas_Mostrador_Indices',
  GASTOS:'Gastos',
  GASTOS_INDICES:'Gastos_Indices',
  CATEGORIAS:'Categorias',
  PACIENTES_INDICES:'Pacientes_Indices_Generales',
  PACIENTES_INDICESV2:'Pacientes_IndicesV2',
  PROPIETARIOS_INDICESV2: 'Propietarios_IndicesV2',
}


// WEBPACK FOOTER //
// ./src/firebase.js